module.exports = __webpack_public_path__ + "img/consCent.a61f2489.jpg";